module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"refresh_happening_in":"Auto refresh in:","units":"seconds","refresh_now":"refresh data now"},"nl":{"refresh_happening_in":"Gegevens worden ververst over:","units":"s","refresh_now":"ververs gegevens nu"}}')
  delete Component.options._Ctor
}
